module.exports = __webpack_public_path__ + "static/media/theft-protection_color.5e4f8478.png";